import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import MembershipNavbar from '../../Components/Membership/MembershipNavbar'
import { BASE_URL_API } from '../../References/URLs'
import ActiveStoreContext from '../../store/ActiveStoreContext'
import AuthContext from '../../store/auth-context'
import ConfigMembershipCards from './ConfigMembershipCards'
import styles from './MembershipHome.module.css'
import MembershipLanding from './MembershipLanding'
import MembershipList from './MembershipList'
import MembershipSettings from './MembershipSettings'

const MembershipHome = () => {
    const { pageIdentifier, membershipIdentifier } = useParams()
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext)
    const activeStore = (() => { try { return asCtx?.activeStore && asCtx.activeStore.trim() !== "" ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();
    const vendorIdentifier = JSON.parse(authCtx?.loginData)?.partnersData?.vendorIdentifier
    const [isCreating, setIsCreating] = useState(false)
    const nav = useNavigate()
    const [isEnabled, setIsEnabled] = useState(false)


    const getMembershipEnableStatus = async () => {
        setIsCreating(true)
        const response = await fetch(BASE_URL_API + "getMembershipEnableStatus",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    vendorIdentifier: vendorIdentifier,
                    storeIdentifier: activeStore?.storeIdentifier
                })
            });

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo?.status === "success") {
                setIsEnabled(true)
            } else {
                if (respo?.message === "tokenExpired") {
                    authCtx.logout()
                }
                setIsEnabled(false)
            }
        }
        setIsCreating(false)
    }

    useEffect(() => {
        if (activeStore !== null) {
            getMembershipEnableStatus()
        }
    }, [asCtx])


    if (activeStore === null) {
        return (
            <div>
                Please select a store first!
            </div>
        )
    }


    return (
        <div className={styles.mainWrapper}>
            <MembershipNavbar />
            <div className={styles.mainBody}>
                {pageIdentifier === 'home' &&
                    <>
                        {isEnabled === true ?
                            <MembershipList />
                            :
                            <MembershipLanding />
                        }
                    </>
                }
                {pageIdentifier === 'reports' && "reports"}
                {pageIdentifier === 'analytics' && "analytics"}
                {pageIdentifier === 'settings' && <MembershipSettings />}
                {membershipIdentifier && (<ConfigMembershipCards membershipIdentifier={membershipIdentifier} />)}
            </div>
        </div>
    )
}

export default MembershipHome